/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { getAccessToken } from '@/libs/firebaseAuth';
import { getBaseUrl } from '@/libs/env';
import { error } from '@/libs/notification';
import { handleAuthorizationError } from '@/libs/apiErrorHandler';
import { enrichOrderAutoMapDisplayNames } from '@/libs/orderAutoMap';

const basePath = () => getBaseUrl() + '/master/order-auto-maps';

function normalizeRow(row: any) {
  if (!row) return row;
  let normalized = row;
  if (row.condition != null && typeof row.condition === 'object') {
    normalized = { ...row, condition: JSON.stringify(row.condition) };
  }
  return enrichOrderAutoMapDisplayNames({
    ...normalized,
    isUseMasterPrice: normalized.isUseMasterPrice ?? false
  });
}

function toApiBody(row: any) {
  const body = { ...row };
  delete body.id;
  delete body.deviceTypeName;
  delete body.productName;
  if (typeof body.condition === 'string') {
    try {
      body.condition = JSON.parse(body.condition);
    } catch {
      return body;
    }
  }
  if (body.condition?.rules) {
    body.condition = { rules: body.condition.rules };
  }
  return body;
}

export default {
  namespaced: true,
  state: {
    listData: [],
    loading: false
  },
  mutations: {
    setListData(state: any, payload: any[]) {
      state.listData = payload;
    },
    setLoading(state: any, payload: boolean) {
      state.loading = payload;
    }
  },
  actions: {
    async fetch(context: any) {
      context.commit('setLoading', true);
      try {
        const { data } = await axios.get(basePath(), {
          headers: { auth: await getAccessToken() }
        });
        context.commit(
          'setListData',
          Array.isArray(data) ? data.map(normalizeRow) : []
        );
      } catch (e: any) {
        if (e.response?.status === 401) {
          await handleAuthorizationError();
        } else {
          error(e.response?.status || '', 'データ取得に失敗しました');
        }
      } finally {
        context.commit('setLoading', false);
      }
    },
    async create(_context: any, row: any) {
      await axios
        .post(basePath(), toApiBody(row), {
          headers: { auth: await getAccessToken() }
        })
        .catch(async (e) => {
          if (e.response?.status === 401) {
            await handleAuthorizationError();
          } else {
            throw e;
          }
        });
    },
    async update(_context: any, row: any) {
      const { id } = row;
      await axios
        .put(`${basePath()}/${id}`, toApiBody(row), {
          headers: { auth: await getAccessToken() }
        })
        .catch(async (e) => {
          if (e.response?.status === 401) {
            await handleAuthorizationError();
          } else {
            throw e;
          }
        });
    },
    async delete(_context: any, id: number | string) {
      await axios
        .delete(`${basePath()}/${id}`, {
          headers: { auth: await getAccessToken() }
        })
        .catch(async (e) => {
          if (e.response?.status === 401) {
            await handleAuthorizationError();
          } else {
            throw e;
          }
        });
    }
  }
};
